import React from "react";
import SeoHead from "../../components/SeoHead";
import Header from "../../components/MainHeader";
import SubBanner from "../../components/SubBanner";
import { Global, Collection, Jobs } from "@sourceflow-uk/sourceflow-sdk";
import SimplePage from "../../components/SimplePage";
import SimpleImageWithText from "../../components/SimpleImageWithText";
import SimpleTwoColumns from "../../components/SimpleTwoColumns";
import stripTags from "../../functions/stripTags";
import SimpleTextWithText from "../../components/SimpleTextWithText";
import LatestJobs from "../../components/LatestJobs";
import TextWithCTA from "../../components/TextWithCTA";
import SourceFlowText from "@sourceflow-uk/sourceflowtext"

export default function ClientsPage({ clientsDetails, all_jobs, textBlockRows }) {
  return (
    <>
      <SeoHead
        // site_name={`Driving Force`}
        page_name={`Employers - ${clientsDetails.title}`}
        // description={``}
        canonical_link={`/clients-page//${clientsDetails.url_slug}/`}
      />
      <Header slug_url={`${clientsDetails.url_slug}`} />

      <SubBanner
        global={global}
        pathPrefix={`employers_specialsm_page.sub_banner`}
        customClass={`mb-5 client-banner`}
        buttonTitle={`Job Search By Client`}
        buttonLink={`/job-search-by-client`}
        customBannerColor={clientsDetails.main_banner_hex_color_code}
        consultantPage={false}
        heading={`${clientsDetails.title}`}
        post={clientsDetails}
        bannerImageAlt={`${clientsDetails.title} Banner Image`}
        bannerImageAlt2={`${clientsDetails.title} Banner Image 2`}
        bannerImage={`${
          clientsDetails.image
            ? clientsDetails.image
            : "/site-assets/images/image-placeholder.webp"
        }`}
        bannerImage2={`${
          clientsDetails.secondary_banner_image
            ? clientsDetails.secondary_banner_image
            : "/site-assets/images/image-placeholder.webp"
        }`}
        dualBannerImage={true}
      />
      <SimpleTwoColumns
        global={global}
        customClass={`mb-5 text-center`}
        content1={
          <div
            dangerouslySetInnerHTML={{ __html: clientsDetails.intro }}
          />
        }
        content2={``}
        // bottomBannerCTA={true}
        // buttomBannerCTALINK={`/jobs/internal/`}
        // buttomBannerCTATitle={`join gap personnel`}
      />

      <SimpleImageWithText
        global={global}
        pathPrefix={`dfr_careers_page.simple_image_with_text`}
        customClass={` pb-5 mt-5 pt-4`}
        backgroundColor={clientsDetails.jobs_available_list_hex_color_code}
        content1={
          <div
            className="description"
            dangerouslySetInnerHTML={{ __html: clientsDetails?.jobs_available_list }}
          />
        }
        imageAltText={`Gap Personnel Careers Benefits Image`}
        imageUrl={`${
          clientsDetails.image_with_text
            ? clientsDetails.image_with_text
            : "/site-assets/images/image-placeholder.webp"
        }`}
      />
      <SimpleTextWithText
        global={global}
        pathPrefix={`client-page.simple_image_with_text`}
        customClass={` mb-5`}
        logoImage={clientsDetails.what_makes_it_different_logo}
        logoImageAlt={`${clientsDetails.title} logo`}
        colorCodeContent1={clientsDetails.sounds_like_a_color_hex_color_code}
        colorCodeContent2={clientsDetails.what_makes_it_diffrent_hex_color_code}
        content1={
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: clientsDetails?.sounds_like_a_good_fit
            }}
          />
        }
        content2={
          <div
            className="description"
            dangerouslySetInnerHTML={{ __html: clientsDetails?.what_makes_it_different }}
          />
        }
      />

      <LatestJobs
        global={global}
        pathPrefix={`homepage.latest_jobs`}
        customClass={`mt-3 mb-5`}
        bgColor={clientsDetails.live_jobs_hex_color_code}
        colorCode={clientsDetails.live_jobs_hex_color_code}
        buttoncolor={clientsDetails.live_jobs_hex_color_code}
        buttonTitle={`view all jobs`}
        buttonLink={`/jobs/#/${clientsDetails.url_slug}`}
        heading={`Find work that suits you`}
        subtitle={`jobseekers`}
        label={false}
        all_jobs={all_jobs}
      />
      {textBlockRows?.map((row, index) =>
        row.length === 2 ? (
          <SimpleTextWithText
            key={index}
            global={global}
            pathPrefix={`client-page.add_text_block`}
            customClass={`mb-5`}
            colorCodeContent2={row[0].content_block_hex_color_code}
            colorCodeContent1={row[1].content_block_hex_color_code}
            content2={
              <div
                className="description"
                dangerouslySetInnerHTML={{ __html: row[0].content_block }}
              />
            }
            content1={
              <div
                className="description"
                dangerouslySetInnerHTML={{ __html: row[1].content_block }}
              />
            }
          />
        ) : (
          <SimpleTwoColumns
            key={index}
            global={global}
            pathPrefix={`client-page.add_text_block`}
            customClass={`mb-5`}
            colorCode={row[0].content_block_hex_color_code}
            content1={
              <div
                className="text-white description"
                dangerouslySetInnerHTML={{ __html: row[0].content_block }}
              />
            }
            content2={""}
          />
        )
      )}
      <SimpleTwoColumns
        global={global}
        pathPrefix={`client-page.simple_two_columns`}
        customClass={`mb-5 `}
        colorCode={clientsDetails.get_in_touch_hex_color_code}
        content1={
          <div className="text-white text-decoration-none">
            <div className="w-100 d-inline-block mb-4">
              <h1>Get in touch</h1>
            </div>
            <div className="d-flex justify-content-between">
              <div className="d-flex-row p-2">
               {clientsDetails.branch}
              </div>
              <div className="d-flex-row p-2">
                <div>
                  <p>
                    Tel:{" "}
                    <a
                      className="text-white text-decoration-none"
                      href={`tel:${clientsDetails.contact_number}`}
                    >
                      {clientsDetails.contact_number}
                    </a>
                  </p>
                </div>
                <div>
                  <p>
                    Email:{" "}
                    <a
                      className="text-white text-decoration-none"
                      href={`mailto:${clientsDetails.company_email}`}
                    >
                      {clientsDetails.company_email}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        }
        content2={""}
        // bottomBannerCTA={true}
        // buttomBannerCTALINK={`/jobs/internal/`}
        // buttomBannerCTATitle={`join gap personnel`}
      />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const clientsCollection = await Collection("client_landing_page");
  const clientsDetails = clientsCollection.getJsonItem(
    params.url_slug,
    "url_slug"
  );

  // Template (repeater) fields hold arrays, which getJsonItem/toJson resolves
  // to null (it only unwraps { en: ... } values), so read them from the raw item.
  const rawClient = clientsCollection.items?.find(
    (item) => item.url_slug === params.url_slug
  );
  const textBlocks = (rawClient?.add_text_block?.en ?? []).filter(
    (entry) => entry?.content_block
  );

  // "1/2" blocks pair up side by side in one row; "Full Width" gets its own row.
  const textBlockRows = [];
  textBlocks.forEach((block) => {
    const lastRow = textBlockRows[textBlockRows.length - 1];
    if (
      block.column_size === "1/2" &&
      lastRow?.length === 1 &&
      lastRow[0].column_size === "1/2"
    ) {
      lastRow.push(block);
    } else {
      textBlockRows.push([block]);
    }
  });

  const all_jobs = (await Jobs())
    .filter(function (job) {
        return (
          job.categories
          // Pulls client category
          .find((cat) => cat.id === "5eac1d7e-f98e-4892-a281-29a1b974bae6")
          ?.values?.map(cat => cat.id).includes(clientsDetails.id)
        );
    })
    .filter(function (job) {
      return new Date(job?.expires_at) >= new Date();
    })
    .getItems()
    .slice(0, 8);

  return {
    props: {
      global,
      clientsDetails,
      all_jobs,
      textBlockRows,
    },
  };
}

export async function getStaticPaths() {
  const pagePath = (await Collection("client_landing_page")).getPaths(
    "url_slug"
  );
  return {
    paths: pagePath,
    fallback: false,
  };
}
